export const PHONE_NUMBER_SPECIFICATIONS = {
    INTERNATIONAL: {
        MAX_LENGTH: 13,
    },
    US_CANADA: {
        PHONE_LENGTH: 10,
        MASK_LENGTH: 14,
    },
} as const;
